module.exports = __webpack_public_path__ + "img/5.05.thmb.xs.ec8ddbc8.jpg";